const translationKeys = {
  cards_card_settings_ecommerce_max_amount_edit_button:
    'cards_card_settings_ecommerce_max_amount_edit_button',
  cards_card_settings_ecommerce_unavailable_message:
    'cards_card_settings_ecommerce_unavailable_message',
  cards_card_settings_ecommerce_error_message:
    'cards_card_settings_ecommerce_error_message',
  cards_card_settings_ecommerce_max_amount_description:
    'cards_card_settings_ecommerce_max_amount_description',
  cards_card_settings_ecommerce_amount_type_description:
    'cards_card_settings_ecommerce_amount_type_description',
  cards_card_settings_ecommerce_max_amount_save_button:
    'cards_card_settings_ecommerce_max_amount_save_button',
  cards_card_settings_ecommerce_toggler_description:
    'cards_card_settings_ecommerce_toggler_description',
  cards_card_settings_ecommerce_section_title:
    'cards_card_settings_ecommerce_section_title',
  cards_card_settings_ecommerce_max_amount_cancel_button:
    'cards_card_settings_ecommerce_max_amount_cancel_button',
  cards_card_settings_ecommerce_amount_type_unlimited_button:
    'cards_card_settings_ecommerce_amount_type_unlimited_button',
  cards_card_settings_ecommerce_amount_type_limited_button:
    'cards_card_settings_ecommerce_amount_type_limited_button',
  cards_card_settings_ecommerce_toggler_off_button:
    'cards_card_settings_ecommerce_toggler_off_button',
  cards_card_settings_ecommerce_toggler_on_button:
    'cards_card_settings_ecommerce_toggler_on_button',
  cards_card_settings_ecommerce_max_amount_invalid_input:
    'cards_card_settings_ecommerce_max_amount_invalid_input',
  cards_list_header_my_cards_title: 'cards_list_header_my_cards_title',
  cards_list_header_my_cards_description:
    'cards_list_header_my_cards_description',
  cards_list_header_others_cards_title: 'cards_list_header_others_cards_title',
  cards_list_header_others_cards_description:
    'cards_list_header_others_cards_description',
  cards_list_header_block_cards_button: 'cards_list_header_block_cards_button',
  cards_list_header_replace_card_button:
    'cards_list_header_replace_card_button',
  cards_list_header_order_new_card_button:
    'cards_list_header_order_new_card_button',
  cards_list_header_tabs_my_cards: 'cards_list_header_tabs_my_cards',
  cards_list_header_tabs_others_cards: 'cards_list_header_tabs_others_cards',
  cards_list_error_title: 'cards_list_error_title',
  cards_list_error_message: 'cards_list_error_message',
  cards_list_active_cards_section_title:
    'cards_list_active_cards_section_title',
  cards_list_blocked_cards_section_title:
    'cards_list_blocked_cards_section_title',
  cards_list_expired_cards_section_title:
    'cards_list_expired_cards_section_title',
  cards_list_card_more_information_button:
    'cards_list_card_more_information_button',
  cards_list_card_account_information_text:
    'cards_list_card_account_information_text',
  cards_list_card_status_message_expired:
    'cards_list_card_status_message_expired',
  cards_list_card_status_message_blocked:
    'cards_list_card_status_message_blocked',
  cards_list_card_status_message_replaced:
    'cards_list_card_status_message_replaced',
  cards_list_card_status_message_order_in_process:
    'cards_list_card_status_message_order_in_process',
  cards_list_card_status_message_new_card_ordered:
    'cards_list_card_status_message_new_card_ordered',
  cards_block_header_title: 'cards_block_header_title',
  cards_block_header_description: 'cards_block_header_description',
  cards_block_error_title: 'cards_block_error_title',
  cards_block_error_message: 'cards_block_error_message',
  cards_block_no_cards_title: 'cards_block_no_cards_title',
  cards_block_no_cards_description: 'cards_block_no_cards_description',
  cards_block_no_cards_go_back_button: 'cards_block_no_cards_go_back_button',
  cards_block_no_cards_order_card_button:
    'cards_block_no_cards_order_card_button',
  cards_block_card_blocking_error_message:
    'cards_block_card_blocking_error_message',
  cards_card_information_header_more_options_button:
    'cards_card_information_header_more_options_button',
  cards_card_information_header_block_button:
    'cards_card_information_header_block_button',
  cards_card_information_header_unblock_button:
    'cards_card_information_header_unblock_button',
  cards_card_information_header_replace_button:
    'cards_card_information_header_replace_button',
  cards_card_information_header_settings_button:
    'cards_card_information_header_settings_button',
  cards_card_information_details_section_title:
    'cards_card_information_details_section_title',
  cards_card_information_account_section_title:
    'cards_card_information_account_section_title',
  cards_card_information_details_section_card_owner:
    'cards_card_information_details_section_card_owner',
  cards_card_information_details_section_card_type:
    'cards_card_information_details_section_card_type',
  cards_card_block_header_title: 'cards_card_block_header_title',
  cards_card_block_header_message: 'cards_card_block_header_message',
  cards_card_block_card_blocked_message:
    'cards_card_block_card_blocked_message',
  cards_card_block_card_expired_message:
    'cards_card_block_card_expired_message',
  cards_card_block_card_updating_message:
    'cards_card_block_card_updating_message',
  cards_card_block_card_update_failed_message:
    'cards_card_block_card_update_failed_message',
  cards_card_replace_header_title: 'cards_card_replace_header_title',
  cards_card_replace_summary_title: 'cards_card_replace_summary_title',
  cards_card_replace_summary_description:
    'cards_card_replace_summary_description',
  cards_card_replace_order_button: 'cards_card_replace_order_button',
  cards_card_replace_summary_card_information_title:
    'cards_card_replace_summary_card_information_title',
  cards_card_replace_summary_account_information_title:
    'cards_card_replace_summary_account_information_title',
  cards_card_replace_summary_customer_information_title:
    'cards_card_replace_summary_customer_information_title',
  cards_card_replace_order_in_progress: 'cards_card_replace_order_in_progress',
  cards_card_replace_order_success_title:
    'cards_card_replace_order_success_title',
  cards_card_replace_order_success_message:
    'cards_card_replace_order_success_message',
  cards_card_replace_order_success_go_to_card_info_button:
    'cards_card_replace_order_success_go_to_card_info_button',
  cards_breadcrumb_home_label: 'cards_breadcrumb_home_label',
  cards_breadcrumb_cards_label: 'cards_breadcrumb_cards_label',
  cards_card_settings_header_title: 'cards_card_settings_header_title',
  cards_card_settings_ecommerce_max_amount_input_placeholder:
    'cards_card_settings_ecommerce_max_amount_input_placeholder',
  cards_breadcrumb_block_cards_label: 'cards_breadcrumb_block_cards_label',
  cards_card_information_order_status_section_title:
    'cards_card_information_order_status_section_title',
  cards_block_card_section_active_cards_title:
    'cards_block_card_section_active_cards_title',
  cards_block_card_section_blocked_cards_title:
    'cards_block_card_section_blocked_cards_title',
  cards_block_card_header_tabs_other_cards:
    'cards_block_card_header_tabs_other_cards',
  cards_block_card_header_tabs_my_cards:
    'cards_block_card_header_tabs_my_cards',
  cards_block_card_subtitle: 'cards_block_card_subtitle',
  cards_block_card_actions_dropdown: 'cards_block_card_actions_dropdown',
  cards_block_card_actions_button: 'cards_block_card_actions_button',
  cards_block_card_actions_dropdown_options_block:
    'cards_block_card_actions_dropdown_options_block',
  cards_block_card_blocked_information_message:
    'cards_block_card_blocked_information_message',
  cards_block_card_actions_dropdown_options_replace:
    'cards_block_card_actions_dropdown_options_replace',
  cards_block_card_confirm_block_title: 'cards_block_card_confirm_block_title',
  cards_block_card_confirm_block_subtitle:
    'cards_block_card_confirm_block_subtitle',
  cards_block_card_confirm_block_confirm_button:
    'cards_block_card_confirm_block_confirm_button',
  cards_block_card_confirm_block_cancel_button:
    'cards_block_card_confirm_block_cancel_button',
  cards_block_card_confirm_un_block_title:
    'cards_block_card_confirm_un_block_title',
  cards_block_card_confirm_un_block_subtitle:
    'cards_block_card_confirm_un_block_subtitle',
  cards_block_card_confirm_un_block_cancel_button:
    'cards_block_card_confirm_un_block_cancel_button',
  cards_block_card_confirm_un_block_confirm_button:
    'cards_block_card_confirm_un_block_confirm_button',
  cards_block_card_confirm_un_block_loading_title:
    'cards_block_card_confirm_un_block_loading_title',
  cards_block_card_confirm_un_block_loading_subtitle:
    'cards_block_card_confirm_un_block_loading_subtitle',
  cards_block_card_confirm_un_block_loading_progressbar:
    'cards_block_card_confirm_un_block_loading_progressbar',
  cards_block_card_confirm_un_block_success_title:
    'cards_block_card_confirm_un_block_success_title',
  cards_block_card_confirm_un_block_success_subtitle:
    'cards_block_card_confirm_un_block_success_subtitle',
  cards_block_card_confirm_un_block_success_close_button:
    'cards_block_card_confirm_un_block_success_close_button',
  cards_block_card_confirm_block_success_title:
    'cards_block_card_confirm_block_success_title',
  cards_block_card_confirm_block_success_close_button:
    'cards_block_card_confirm_block_success_close_button',
  cards_block_card_confirm_block_loading_title:
    'cards_block_card_confirm_block_loading_title',
  cards_block_card_confirm_block_loading_subtitle:
    'cards_block_card_confirm_block_loading_subtitle',
  cards_block_card_confirm_block_loading_progressbar:
    'cards_block_card_confirm_block_loading_progressbar',
};

Object.freeze(translationKeys);

export default translationKeys;
